(function() {
  var Service,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  exports.register = function(module) {
    return module.service('Core.Services.Session', ['$cookies', exports.Session]);
  };

  exports.Session = (function(superClass) {
    extend(Session, superClass);

    function Session(cookies) {
      this.cookies = cookies;
      this.remove = bind(this.remove, this);
      this.get = bind(this.get, this);
      this.set = bind(this.set, this);
      void 0;
    }

    Session.prototype.set = function(name, value) {
      return this.cookies.put(name, '' + value);
    };

    Session.prototype.get = function(name) {
      return this.cookies.get(name);
    };

    Session.prototype.remove = function(name) {
      return this.cookies.remove(name);
    };

    return Session;

  })(Service);

}).call(this);
